import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateItemEntity } from '../../domain/entities/CreateUpdateItemEntity'
import type { PostSelectionSigmaRequest } from '@/backend/market'
import { CreateUpdateItemGalleryModel } from './CreateUpdateItemGalleryModel'
import type { FileUploadEntity } from '@/shared/entities/FileUploadEntity'

export class CreateUpdateItemModel extends CreateUpdateItemEntity { 
  branchId!: number
  venderId?: number | null
  categoryId!: number
  selections?: Array<PostSelectionSigmaRequest> | null
  image?: FileUploadEntity | null
  itemUnitId!: number | null;

  constructor(dataDto: CreateUpdateItemEntity) {
    super()
    const createUpdateItemGalleryModel = dataDto.itemGalleries?.map(
      (gallery) => new CreateUpdateItemGalleryModel(gallery)
    )
    mapEntityProperties<CreateUpdateItemModel>(this, dataDto, {
      exclude: ['imageData', 'imageUrl', 'branch', 'vender', 'category', 'attributes', 'itemUnit', 'externalBranchDiscountAmount', 'sku'],
      map: {
        itemUnitId: dataDto.itemUnit?.id,
        image: dataDto?.imageData?.removeFile ? { removeFile: true } : dataDto?.imageData,
        itemGalleries: createUpdateItemGalleryModel,
        branchId: dataDto.branch?.id,
        venderId: dataDto.vender?.id,
        categoryId: dataDto.category?.id,
        selections: dataDto.attributes?.map((attr) => ({
          ...attr,
          itemValues: attr.itemValues?.map((item) => ({
            itemId: item.id
          }))
        }))
      }
    })
  }
}
